import React, {useEffect, useState} from 'react';

import {Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Modal, Row} from 'reactstrap';
import localeHelpers from "../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../translations/alert_translations";
import {common_strings} from "../translations/common_translations";
import {RotateCircleLoading} from "react-loadingg";
import {resource_strings} from "../translations/resource_translations";
import resourceHelper from "../helpers/ResourceHelper";
import ResourceApiService from "../api/resource-api-service";
import stripeSvg from "../assets/img/icons/common/stripe_white.png";
import TicketTypeApiService from "../api/tt-api-service";
import ResourceItem from "./Lists/ResourceItem";
import businessHelper from "../helpers/BusinessHelper";
import PartnerSearch from "./Search/PartnerSearch";

let alertStrings = new LocalizedStrings(alert_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const selectButtonStyle = {minWidth: 250, marginBottom: 10, marginLeft: 0, marginRight: 0};
const secondaryColor = "#afbac5";

const PaymentModal = (props) => {
    const [visible, setVisible] = useState(true);
    const [product, setProduct] = useState(resourceHelper.emptyProduct());
    const [ticketType, setTicketType] = useState(null);
    const [ticketTypes, setTicketTypes] = useState([]);
    const [mode, setMode] = useState('select');
    const [isLoading, setIsLoading] = useState(false);
    const [shouldShowTicketTypes, setShouldShowTicketTypes] = useState(false);
    const [shouldShowStudentsModal, setShouldShowStudentsModal] = useState(false);
    const [partner, setPartner] = useState(null);
    const [isDataValid, setIsDataValid] = useState(false);
    const [link, setLink] = useState(null);
    const [error, setError] = useState(null);
    const [products, setProducts] = useState([]);
    const [shouldShowProducts, setShouldShowProducts] = useState(false);

    const onDismiss = () => setVisible(false);

    function toggle() {
        if (visible) {
            onResetMode()
        }

        setVisible(!visible);
        props.toggleModal();
    }

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    const handleChange = (e) => {
        const curProduct = JSON.parse(JSON.stringify(product));
        let newValue = e.target.value;

        switch (e.target.id) {
            case "input-title":
                curProduct.title = e.target.value;
                break;
            case "input-description":
                curProduct.description = e.target.value;
                break;
            case "input-gift-card-cb":
                curProduct.isGiftCard = e.target.checked;
                break;
            case "input-destination-email":
                curProduct.destinationEmail = newValue;
                break;
            case "input-email-text":
                curProduct.emailText = e.target.value;
                break;
            case "input-price":
                curProduct.price = parseFloat(newValue);
                break;
            default:
                break;
        }

        setProduct(curProduct);
    };

    useEffect(() => {
        checkIfDataIsValid()
    }, [product])

    localize();

    function saveProduct(e) {
        setIsLoading(true);
        e.preventDefault();

        const productParams = {
            title: product.title,
            description: product.description,
            email_text: product.emailText,
            destination_email: product.destinationEmail,
            is_gift_card: product.isGiftCard,
            ticket_type_id: product.ttId,
            product_id: product.id,
            price: product.price
        }

        ResourceApiService.saveProduct(productParams)
            .then(res => {
                setIsLoading(false);
                if (res.link) {
                    setLink(res.link)
                    setMode('link_sent')
                } else {
                    setMode('link_sent')
                    setError(alertStrings.generic_error)
                }
            })
            .catch((e) => {
                props.handleError(e)
            });
    }

    function deleteProduct() {
        ResourceApiService.deleteProduct(product.id)
            .then(res => {
                setProduct(resourceHelper.emptyProduct)
                setIsLoading(false);
                loadProducts()
            })
            .catch((e) => {
                props.handleError(e)
            });
    }

    function onResetMode(e) {
        setPartner(null)
        setTicketType(null)
        setIsLoading(false)
        setProduct(resourceHelper.emptyProduct)
        setShouldShowTicketTypes(false)
        setShouldShowProducts(false)
        setLink(null)
        setMode('select')
    }

    function previewLink(e) {
        // let a = document.createElement("a");
        // document.body.appendChild(a);
        // a.style = "display: none";
        // a.href = link;
        // a.click();
        // document.body.removeChild(a);
    }

    function connectStripeAction(e) {
        e.preventDefault();
        window.location.replace(`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_FVVYQ2LLjNcHkpAX2boYnb7ChHJDTXGp&scope=read_write&&redirect_uri=https://www.openmanagerapp.com/admin/`);
    }

    return (
        <Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-danger"
            isOpen={visible}
            toggle={() => toggle("notificationModal")}
        >
            {shouldShowStudentsModal &&
                renderStudentSearchModal()
            }

            <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {isLoading &&
                        <RotateCircleLoading color="white"/>
                    }
                    <Row className="align-items-center">
                        <div className="col">
                            <h2 className="text-white mb-0">{resourceStrings.payment.payment}</h2>
                        </div>

                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => toggle("notificationModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </Row>
                </CardHeader>
                <CardBody>

                    {mode !== 'link_sent' &&
                        <label className="text-white mb-0">{resourceStrings.payment.powered_by_stripe}</label>
                    }

                    {mode !== 'link_sent' &&
                        <img
                            style={{marginLeft: 10}}
                            alt="stripe"
                            width={39}
                            height={39}
                            src={stripeSvg}/>
                    }

                    {mode !== 'link_sent' &&
                        <label style={{color: secondaryColor}}
                               className="mb-6">{resourceStrings.payment.payment_expl}</label>
                    }

                    {(shouldShowTicketTypes || shouldShowProducts) &&
                        <div>

                            <div style={{display: "flex", justifyContent: "flex-end", marginBottom: 10}}>
                                <Button
                                    color={"white"}
                                    type="button"
                                    size="sm"
                                    onClick={e => onResetMode(e)}
                                >
                                    {commonStrings.cancel}
                                </Button>
                            </div>

                            <div>{shouldShowTicketTypes ? renderTicketTypes() : renderProducts()}</div>

                        </div>
                    }

                    {(((mode === 'product' || mode === 'ticket_type') && (ticketType || (product && product.id))) || mode === 'new_product') &&
                        <span>{renderForm()}</span>
                    }
                    {mode === 'select' && businessHelper.business().stripe_id &&
                        <div style={{
                            display: "flex",
                            flexFlow: "column",
                            alignItems: 'center',
                            justifyContent: "center"
                        }}>
                            <Button
                                color={"primary"}
                                type="button"
                                size="lg"
                                style={selectButtonStyle}
                                onClick={e => onTicketModeSelected(e)}
                            >
                                {resourceStrings.select_tt}
                            </Button>

                            <Button
                                color={"primary"}
                                type="button"
                                size="lg"
                                style={selectButtonStyle}
                                onClick={e => onProductModeSelected(e)}
                            >
                                {resourceStrings.payment.select_product}
                            </Button>

                            <Button
                                color={"white"}
                                type="button"
                                size="lg"
                                className="mt-4"
                                style={selectButtonStyle}
                                onClick={e => onNewProductModeSelected(e)}
                            >
                                {resourceStrings.payment.new_product}
                            </Button>
                        </div>
                    }

                    {mode === 'select' && !businessHelper.business().stripe_id &&
                        <div style={{
                            display: "flex",
                            flexFlow: "column",
                            alignItems: 'center',
                            justifyContent: "center"
                        }}>

                            <div style={{fontWeight: 600}}>
                                {resourceStrings.public_profile.stripe_expl_intro}
                            </div>

                            <a style={{marginTop: 20}} href={"https://stripe.com/en-es/pricing?locale=ru"} target="_blank">
                                {resourceStrings.public_profile.stripe_expl_intro_2}
                            </a>

                            <Button
                                style={{
                                    display: "flex",
                                    marginBottom: 20,
                                    marginTop: 20,
                                    alignItems: "center"
                                }}
                                color="info"
                                size="lg"
                                onClick={connectStripeAction}
                            >
                                {resourceStrings.public_profile.connect_stripe}
                            </Button>
                        </div>
                    }

                    {mode === 'link_sent' && link &&
                        <div style={{
                            display: "flex",
                            flexFlow: "column",
                            alignItems: 'center',
                            justifyContent: "center"
                        }}>
                            <label className="mb-4 text-black-60">✨ {resourceStrings.payment.link_sent_success}</label>
                            <label className="mt-2 mb-6 text-center">{product.ttId ? resourceStrings.payment.link_sent_success_ticket : resourceStrings.payment.link_sent_success_income}</label>
                            <Button
                                color={"white"}
                                type="button"
                                size="lg"
                                href={link} target="blank"
                                style={selectButtonStyle}
                            >
                                {resourceStrings.payment.preview_link}
                            </Button>

                            <Button
                                color={"white"}
                                type="button"
                                size="lg"
                                style={{marginBottom: 6, marginRight: 0, marginLeft: 6, minWidth: 250}}
                                onClick={e => onResetMode(e)}
                            >
                                {commonStrings.restart}
                            </Button>
                        </div>
                    }

                    {mode === 'link_sent' && error &&
                        <label className="text-danger mb-4">⚠️ {alertStrings.generic_error}</label>
                    }
                </CardBody>
            </Card>
        </Modal>
    );

    function loadTicketTypes() {
        setIsLoading(true)

        TicketTypeApiService.index()
            .then(res => {
                setTicketTypes(res)
                setIsLoading(false)
                setShouldShowTicketTypes(true)
            })
            .catch((e) => {
                props.handleError(e)
            });
    }

    function onTicketTypeSelected(event, ticketTypeName) {
        const ticketType = ticketTypes.find(tt => tt.name === ticketTypeName)
        if (!ticketType) {
            return
        }

        setTicketType(ticketType)
        setShouldShowTicketTypes(false)

        let tempProduct = product;
        tempProduct.title = ticketType.name;
        tempProduct.description = ticketType.description;
        tempProduct.price = ticketType.price;
        tempProduct.ttId = ticketType.id;

        console.log(JSON.stringify(tempProduct))

        setProduct(tempProduct);
    }

    function loadProducts() {
        setIsLoading(true)

        ResourceApiService.products()
            .then(res => {
                setProducts(res)
                setIsLoading(false)
                setShouldShowProducts(true)
            })
            .catch((e) => {
                props.handleError(e)
            });
    }

    function onProductSelected(event, selectedProductName) {
        const p = products.find(pp => pp.name === selectedProductName)
        if (!p) return
        p.price = parseFloat(p.price) / 100
        p.title = p.name

        setProduct(p)
        setShouldShowProducts(false)
    }

    function renderTicketTypes() {
        return <>
            {ticketTypes.filter(tt => (tt.price && tt.price > 1)).filter(tt => !tt.membership).map((tt) => (
                <ResourceItem
                    key={tt.id.toString()}
                    item_name={tt.name}
                    icon={require("assets/img/icons/common/ticket_white.svg").default}
                    item_extra={`${parseFloat(tt.price).toFixed(2)} ${businessHelper.currency()}`}
                    additionaInfo={""}
                    onSelected={onTicketTypeSelected}
                />
            ))}
        </>
    }

    function renderProducts() {
        return <>
            {products.map((p) => (
                <ResourceItem
                    key={p.id.toString()}
                    item_name={p.name}
                    icon={require("assets/img/icons/common/sales.svg").default}
                    item_extra={`${(parseFloat(p.price) / 100).toFixed(2)} ${businessHelper.currency()}`}
                    additionaInfo={""}
                    onSelected={onProductSelected}
                />
            ))}
        </>
    }

    function onTicketModeSelected() {
        setMode('ticket_type')

        if (!ticketTypes || ticketTypes.length === 0) {
            loadTicketTypes()
        } else {
            setShouldShowTicketTypes(true)
        }
    }

    function onProductModeSelected() {
        setMode('product')

        if (!products || products.length === 0) {
            loadProducts()
        } else {
            setShouldShowProducts(true)
        }
    }

    function onNewProductModeSelected() {
        setMode('new_product')
    }

    function displayPrice() {
        const p = parseFloat(product.price).toFixed(2);
        return numberWithSpaces(p)
    }

    function checkIfDataIsValid() {
        console.log(JSON.stringify(product))

        if (isLoading) {
            setIsDataValid(false)
        } else if (!product) {
            console.log(`111`)
            setIsDataValid(false)
        } else if (product.price && (parseFloat(product.price) < 1 || parseFloat(product.price) > 999)) {
            console.log(`Price invalid`)
            setIsDataValid(false)
        } else if (!product.destinationEmail) {
            console.log(`Email invalid`)
            setIsDataValid(false)
        } else if (product.title.length < 1 || product.price.length < 1 || product.destinationEmail.length < 1) {
            console.log(`222`)
            setIsDataValid(false)
        } else if (product.destinationEmail.indexOf("@") < 0 || product.destinationEmail.indexOf(".") < 0) {
            console.log(`Email invalid`)
            setIsDataValid(false)
        } else {
            console.log(`333`)
            setIsDataValid(true)
        }

    }

    function showStudentModal(e) {
        let p = product;
        p.destinationEmail = ""
        setProduct(p)
        checkIfDataIsValid()
        toggleStudentsModal()
    }

    function priceStyle() {
        if (product.price && (parseFloat(product.price) >= 1 && parseFloat(product.price) < 999)) {
            return {color: null}
        } else {
            return {color: "red"}
        }

    }

    function renderForm() {
        return <Form>
            <div className="pl-lg-12">
                <Row>
                    <Col lg="12">
                        <h3 className="text-white">{resourceStrings.payment.product_details}</h3>

                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-title"
                            >
                                {resourceStrings.title} *
                            </label>
                            <Input
                                disabled={ticketType || (product && product.id)}
                                className="form-control-alternative"
                                onChange={handleChange}
                                placeholder={resourceStrings.title}
                                defaultValue={product.title}
                                id="input-title"
                                type="text"
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col lg="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-description"
                            >
                                {resourceStrings.description}
                            </label>
                            <Input
                                className="form-control-alternative"
                                onChange={handleChange}
                                placeholder={resourceStrings.description}
                                defaultValue={product.description}
                                id="input-description"
                                rows="2"
                                type="textarea"
                            />
                        </FormGroup>
                    </Col>

                    <Col lg="6" sm="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-price"
                                style={priceStyle()}
                            >
                                {resourceStrings.payment.price} ({businessHelper.currency()}) *
                            </label>
                            <Input
                                className="form-control-alternative"
                                onChange={handleChange}
                                defaultValue={displayPrice()}
                                id="input-price"
                                min="0"
                                type="number"
                                // pattern="^\d+(?:\.\d{1,2})?$"
                                placeholder="0.00"
                            />
                        </FormGroup>
                    </Col>

                </Row>

                <hr style={{background: "white", marginBottom: 30, marginTop: 10}}/>

                <Row>
                    <Col lg="12">
                        <h3 className="text-white">{resourceStrings.payment.destination}</h3>

                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-destination-email"
                            >
                                {commonStrings.email} *
                                <div style={{color: secondaryColor}}>{resourceStrings.payment.destination_expl}</div>
                            </label>

                            <div style={{display: "flex", justifyContent: "flex-end", marginBottom: 10}}>
                                <Button
                                    color={"white"}
                                    type="button"
                                    size="sm"
                                    onClick={e => showStudentModal(e)}
                                >
                                    {resourceStrings.invoices.select_partner}
                                </Button>
                            </div>

                            <Input
                                className="form-control-alternative"
                                onChange={handleChange}
                                placeholder={commonStrings.email}
                                // defaultValue={product.destinationEmail}
                                value={product.destinationEmail}
                                id="input-destination-email"
                                type="email"
                            />
                        </FormGroup>
                    </Col>

                    <Col lg="12" sm="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-email-text"
                            >
                                {resourceStrings.payment.email_text}
                            </label>
                            <Input
                                className="form-control-alternative"
                                onChange={handleChange}
                                defaultValue={product.emailText}
                                id="input-email-text"
                                min="0"
                                rows="2"
                                type="textarea"
                                placeholder={resourceStrings.payment.email_text_expl}
                            />
                        </FormGroup>
                    </Col>

                </Row>

                <Row>
                    <Col lg="12" className="text-right mt-3">
                        {product && product.id &&
                            <Button
                                color={"danger"}
                                type="button"
                                size="lg"
                                style={{marginBottom: 6, marginRight: 0, marginLeft: 6}}
                                onClick={e => deleteProduct(e)}
                            >
                                {commonStrings.delete}
                            </Button>
                        }

                        <Button
                            color={"white"}
                            type="button"
                            size="lg"
                            style={{marginBottom: 6, marginRight: 0, marginLeft: 6}}
                            onClick={e => onResetMode(e)}
                        >
                            {commonStrings.restart}
                        </Button>

                        <Button
                            color={"primary"}
                            type="button"
                            disabled={!isDataValid}
                            size="lg"
                            style={{marginBottom: 6, marginRight: 0, marginLeft: 12}}
                            onClick={e => saveProduct(e)}
                        >
                            {resourceStrings.payment.send_payment_link}
                        </Button>
                    </Col>
                </Row>
            </div>
        </Form>
    }

    function renderStudentSearchModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={shouldShowStudentsModal}
                toggle={() => toggleStudentsModal()}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.invoices.select_partner}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <PartnerSearch
                                closeStudentSearchView={closeStudentSearchView}
                                addStudent={onPartnerSelected}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    function toggleStudentsModal() {
        setShouldShowStudentsModal(!shouldShowStudentsModal)
    }

    function closeStudentSearchView(e) {
        this.setState({
            showStudentsModal: false
        });
    }

    function onPartnerSelected(partner) {
        setShouldShowStudentsModal(false)
        setPartner(partner);

        let tempProduct = product;
        tempProduct.destinationEmail = partner.email;
        tempProduct.random_id = Math.floor(Math.random() * (12)) + 1;

        setProduct(tempProduct);

        checkIfDataIsValid()
        console.log(product.destinationEmail + "!!!")
    }

    function numberWithSpaces(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
};

export default PaymentModal;